'use client';

import { c } from '../../../utils/tailwind-merge';
import { IconButton } from '../../atoms/Button/IconButton';
import { ConfirmationPopup } from '../../molecules/ConfirmationPopup';
import { FavoriteListModal } from '../FavoriteListModal';
import { ShareListModal } from '../ShareListModal';
import type { ProductListExistingActionsProps } from './ProductListHeader.types';

export type { ProductListExistingActionsProps };

const responsiveIconClasses =
  'h-5 w-5 lg:h-6 lg:w-6 fill-grey-800 group-hover:fill-blue';

export const ProductListExistingActions = ({
  microcopy,
  favoriteListModalProps,
  confirmationPopupProps,
  shareListModalProps,
  hideShare = false,
  className = '',
  testId = 'product-list-existing-actions',
}: ProductListExistingActionsProps) => {
  return (
    <div className={c('flex items-center gap-2', className)} data-test={testId}>
      <ConfirmationPopup
        {...confirmationPopupProps}
        trigger={
          <IconButton
            iconName="Trash"
            ariaLabel={microcopy.deleteAria}
            iconWeight="bold"
            iconClassName={responsiveIconClasses}
            className="group w-auto p-2 md:p-3"
            testId="product-list-header-delete-button"
          />
        }
      />
      <FavoriteListModal
        {...favoriteListModalProps}
        trigger={
          <IconButton
            iconName="PencilSimple"
            ariaLabel={microcopy.editAria}
            iconWeight="bold"
            iconClassName={responsiveIconClasses}
            className="group w-auto p-2 md:p-3"
            testId="product-list-header-edit-button"
          />
        }
      />
      {!hideShare && (
        <ShareListModal
          {...shareListModalProps}
          trigger={
            <IconButton
              iconName="ShareNetwork"
              ariaLabel={microcopy.shareAria}
              iconWeight="bold"
              iconClassName={responsiveIconClasses}
              className="group w-auto p-2 md:p-3"
              testId="product-list-header-share-button"
            />
          }
        />
      )}
    </div>
  );
};

ProductListExistingActions.displayName = 'ProductListExistingActions';
